/**
 * Created by wuyanbin on 2019/9/19
 */
import { createStore } from '@souche-f2e/muji';
import Api from '@/services';
import { mappingKeyToVal, mappingValToKey } from '@/shared/functions';
import { notification } from 'antd';
// 1店铺保证金; 2单车保证金; 3不收保证金
const depositType = [
    { key: 1, value: 'shopDeposit' },
    { key: 2, value: 'singleCarDeposit' },
    { key: 3, value: 'noDeposit' },
];
const initData = {
    currentDepositType: 'shopDeposit',
    isCanEdit: false,
    transferDeposit: '',
    transferDefault: '',
};
export default createStore({
    state: Object.assign({}, initData),
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
    },
    effects: {
        // 取消编辑
        cancelEdit(payload, { state }) {
            this.changeIsCanEdit({});
            this.getDepositConfigData({});
        },
        // 切换可编辑状态
        changeIsCanEdit(payload, { state, update }) {
            update({ isCanEdit: !state.isCanEdit });
        },
        // 获取保证金规则数据
        getDepositConfigData(payload, { state }) {
            Api.base.getTransferFrozenMoney({}).then((res) => {
                this.SET_STATE({
                    currentDepositType: mappingKeyToVal(depositType, res.type),
                    transferDeposit: res.transferFrozenMoney ? res.transferFrozenMoney : '',
                    transferDefault: res.breakFrozenMoney ? res.breakFrozenMoney : '',
                });
            });
        },
        // 保存数据
        saveData(payload, { state }) {
            const depositConfigData = {
                type: mappingValToKey(depositType, state.currentDepositType),
                transferFrozenMoney: payload.transferDeposit,
                breakFrozenMoney: payload.transferDefault,
            };
            Api.base.saveTransferFrozenMoney(depositConfigData).then((res) => {
                if (res) {
                    notification.success({ message: '保存成功' });
                    this.changeIsCanEdit({});
                }
                else {
                    notification.error({ message: '保存失败,请稍后重试' });
                }
            });
        },
        // 修改保证金类型
        changeDepositType(payload, { state, update }) {
            this.SET_STATE({ currentDepositType: payload });
        },
    },
});
